import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, Stack, useTheme } from "@mui/material";
import {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useRef,
  useState,
} from "react";
import {
  DateRange,
  FromToDateProps,
} from "share-components/atomics/date-range";
import { XButton } from "../button/x-button";
import { XTextField, XTextFieldProps } from "./x-text-field";

type XSearchTextFieldProps3 = {
  xTextFieldProps?: XTextFieldProps;
  dateRangeProps?: FromToDateProps;
  searchFunc?: (text: string) => void;
};
export const XSearchTextField3 = ({
  xTextFieldProps,
  searchFunc,
  dateRangeProps,
}: XSearchTextFieldProps3) => {
  const theme = useTheme();
  const [searchingText, setSearchingText] = useState<string>(
    xTextFieldProps?.value?.toString() || ""
  );
  const inputRef = useRef<HTMLInputElement>(null);

  const onValueChanged = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSearchingText(e.target.value || "");
    },
    []
  );

  const onKeydownHandler = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        searchFunc?.(searchingText);
      }
    },
    [searchFunc, searchingText]
  );

  const onClearClicked = useCallback(() => {
    setSearchingText("");
    searchFunc?.("");
  }, [searchFunc]);

  const onSearchBtnClicked = useCallback(() => {
    searchFunc?.(searchingText);
  }, [searchFunc, searchingText]);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <XTextField
        variant="outlined"
        value={searchingText}
        onChange={onValueChanged}
        onKeyDown={onKeydownHandler}
        placeholder={xTextFieldProps?.placeholder || "Nhập từ khóa"}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon
                sx={{ color: theme.palette.text.primary, opacity: "0.5" }}
              ></SearchIcon>
            </InputAdornment>
          ),
        }}
        showclearicon={true}
        onClearClicked={onClearClicked}
        inputRef={inputRef}
        //   onBlur={onBlurHandler}
        size="small"
        {...xTextFieldProps}
      />

      {dateRangeProps && (
        <Box>
          <DateRange {...dateRangeProps}></DateRange>
        </Box>
      )}

      <XButton variant="contained" onClick={onSearchBtnClicked}>
        Tìm kiếm
      </XButton>
    </Stack>
  );
};

type XSearchTextFieldProps = XTextFieldProps & {
  clearHandler?: () => void;
};
export const XSearchTextField = ({
  clearHandler,
  ...props
}: XSearchTextFieldProps) => {
  const theme = useTheme();

  const inputRef = useRef<HTMLInputElement>(null);

  const onClearClicked = useCallback(() => {
    clearHandler?.();
  }, [clearHandler]);

  return (
    <XTextField
      {...props}
      variant="outlined"
      placeholder={props?.placeholder || "Nhập từ khóa"}
      InputProps={{
        ...props.InputProps,
        // startAdornment: (
        //   <InputAdornment position="start">
        //     <SearchIcon
        //       sx={{ color: theme.palette.text.primary, opacity: "0.5" }}
        //     ></SearchIcon>
        //   </InputAdornment>
        // ),
      }}
      showclearicon={clearHandler ? true : false}
      onClearClicked={onClearClicked}
      inputRef={inputRef}
      size="small"
    />
  );
};
